import PropTypes from 'prop-types';
import { CONTAINER_TYPE } from '../constants';
import { lazy } from 'react';

const LoginContainer = lazy(() => import('./LoginContainer'));
const AdminContainer = lazy(() => import('./AdminContainer'));
const ManagerContainer = lazy(() => import('./ManagerContainer'));
const RecruiterContainer = lazy(() => import('./RecruiterContainer'));
const WfmContainer = lazy(() => import('./WfmContainer'));
const HrContainer = lazy(() => import('./HrContainer'));
const EmployeeContainer = lazy(() => import('./EmployeeContainer'));
import ContainerWrapper from './ContainerWrapper';

const CONTAINER_COMPONENTS = {
    [CONTAINER_TYPE.LOGIN]: LoginContainer,
    [CONTAINER_TYPE.HR]: HrContainer,
    [CONTAINER_TYPE.RECRUITER]: RecruiterContainer,
    [CONTAINER_TYPE.WFM]: WfmContainer,
    [CONTAINER_TYPE.MANAGER]: ManagerContainer,
    [CONTAINER_TYPE.EMPLOYEE]: EmployeeContainer,
    [CONTAINER_TYPE.ADMIN]: AdminContainer,
};

const AppContainer = ({ containerType }) => {
    const Component = CONTAINER_COMPONENTS[containerType] || LoginContainer;
    if (containerType === CONTAINER_TYPE.LOGIN || containerType === CONTAINER_TYPE.ADMIN) {
        return <Component />;
    }

    return (
        <ContainerWrapper>
            <Component />
        </ContainerWrapper>
    );
};

AppContainer.propTypes = {
    containerType: PropTypes.oneOf(Object.values(CONTAINER_TYPE)).isRequired,
};

export default AppContainer;
